var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusInline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.259,
    height: 45.259,
    viewBox: "0 0 45.259 45.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3343",
    "data-name": "Group 3343",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_432",
    "data-name": "Line 432",
    d: "M43.291,3.936H1.968A1.968,1.968,0,0,1,1.968,0H43.291a1.968,1.968,0,0,1,0,3.936Z",
    transform: "translate(45.259 24.597) rotate(180)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_433",
    "data-name": "Line 433",
    d: "M43.291,3.936H1.968A1.968,1.968,0,0,1,1.968,0H43.291a1.968,1.968,0,0,1,0,3.936Z",
    transform: "translate(24.597) rotate(90)",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInline);
export default __webpack_public_path__ + "static/media/plusInline.46a4b3aefcbd24a44b5a54ee9333f148.svg";
export { ForwardRef as ReactComponent };